<template>
</template>

<script>
    export default {
        created: function () {
            this.$store.commit("processing", {start:true, message:"ログアウト中です。"})
        },
        beforeDestroy: function () {
            this.$store.commit("processing")
        }
    }
</script>
